(function () {
  document.addEventListener('click', function (e) {
    // Close button — handle before backdrop check
    var closeBtn = e.target.closest('.comp-modal__close');
    if (closeBtn) {
      closeModal(closeBtn.closest('.comp-modal'));
      return;
    }

    // Open trigger
    var trigger = e.target.closest('.comp-item__trigger');
    if (trigger) {
      var targetModal = document.getElementById(trigger.dataset.compModal);
      if (targetModal) showModal(targetModal);
      return;
    }

    // Click on backdrop (modal overlay but outside the sheet)
    var openModal = document.querySelector('.comp-modal:not([hidden])');
    if (openModal && !e.target.closest('.comp-modal__sheet')) {
      closeModal(openModal);
      return;
    }

    // Option button selection
    var optionBtn = e.target.closest('.comp-modal__option-btn');
    if (optionBtn) {
      var modal = optionBtn.closest('.comp-modal');
      var optionIndex = optionBtn.dataset.optionIndex;
      modal.querySelectorAll('[data-option-index="' + optionIndex + '"]').forEach(function (btn) {
        btn.classList.remove('is-active');
      });
      optionBtn.classList.add('is-active');
      if (optionBtn.dataset.optionName === 'Color') {
        var colorName = modal.querySelector('.comp-modal__color-name');
        if (colorName) colorName.textContent = optionBtn.dataset.optionValue;
        updateColorImage(modal, optionBtn.dataset.optionValue, parseInt(optionBtn.dataset.optionIndex));
      }
      updateVariant(modal);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('.comp-modal:not([hidden])');
      if (open) closeModal(open);
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-type="add-to-cart-form"]');
    if (!form) return;
    var modal = form.closest('.comp-modal');
    if (!modal) return;
    setTimeout(function () { closeModal(modal); }, 50);
  });

  function showModal(modal) {
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    modal.removeAttribute('hidden');
    document.body.classList.add('comp-modal-open');
  }

  function closeModal(modal) {
    modal.setAttribute('hidden', '');
    document.body.classList.remove('comp-modal-open');
  }

  function updateColorImage(modal, colorValue, colorOptionIndex) {
    var productId = modal.id.replace('comp-modal-', '');
    var variantsScript = document.querySelector('[data-comp-variants="' + productId + '"]');
    if (!variantsScript) return;

    var variants = JSON.parse(variantsScript.textContent);
    var match = variants.find(function (v) {
      return v.options[colorOptionIndex] === colorValue && v.featured_image;
    });

    if (match && match.featured_image) {
      var img = modal.querySelector('.comp-modal__image');
      if (img) {
        img.src = match.featured_image.src;
        img.alt = match.featured_image.alt || '';
      }
    }
  }

  function updateVariant(modal) {
    var productId = modal.id.replace('comp-modal-', '');
    var variantsScript = document.querySelector('[data-comp-variants="' + productId + '"]');
    if (!variantsScript) return;

    var variants = JSON.parse(variantsScript.textContent);
    var selectedByIndex = {};
    modal.querySelectorAll('.comp-modal__option-btn.is-active').forEach(function (btn) {
      selectedByIndex[parseInt(btn.dataset.optionIndex)] = btn.dataset.optionValue;
    });

    var match = variants.find(function (v) {
      return Object.keys(selectedByIndex).every(function (i) {
        return v.options[parseInt(i)] === selectedByIndex[i];
      });
    });

    if (!match) return;
    modal.querySelector('[name="id"]').value = match.id;

    var atcBtn = modal.querySelector('.comp-modal__atc');
    var atcLabel = atcBtn.querySelector('span');
    if (match.available) {
      atcBtn.disabled = false;
      atcLabel.textContent = 'ADD TO CART';
    } else {
      atcBtn.disabled = true;
      atcLabel.textContent = 'SOLD OUT';
    }
  }
})();
